import { render, staticRenderFns } from "./LeadNotification.vue?vue&type=template&id=f8f17fc8&scoped=true&"
import script from "./LeadNotification.vue?vue&type=script&lang=js&"
export * from "./LeadNotification.vue?vue&type=script&lang=js&"
import style0 from "./LeadNotification.vue?vue&type=style&index=0&id=f8f17fc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f17fc8",
  null
  
)

export default component.exports